module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12 col-md-8\">\n\n    </div>\n    <div class=\"col-xs-12 col-md-4\">\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/layout.two-columns-2-1.html
// module id = 577
// module chunks = 0